/**
 * Scroll Reveal — IntersectionObserver-based reveal animation
 * Adds .js-enabled to <html> for progressive enhancement.
 * Queries all [data-reveal] elements and adds .is-visible when they enter the viewport.
 */
(function () {
  'use strict';

  // Mark JS as available for CSS progressive enhancement
  document.documentElement.classList.add('js-enabled');

  // H7: If user prefers reduced motion, reveal everything instantly (no animation)
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  function observe() {
    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  // Run on initial load
  observe();

  // Also observe elements added dynamically (e.g. via Shopify sections)
  if ('MutationObserver' in window) {
    var pendingObserve = false;
    var mutationObserver = new MutationObserver(function () {
      if (pendingObserve) return;
      pendingObserve = true;
      requestAnimationFrame(function () {
        observe();
        pendingObserve = false;
      });
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
